/**
 * article模块接口列表
 */
import base from '../base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例

const mainpageApi = {
    getMainPageConfig: function (number) {
        const params = {
            "apiname": "srmmainpage",
            "methodname": "getMainPageConfig",
            "language":number
        };
        let query = window.location.search.substring(1);
        if (query != null){
         let vars = query.split("&");
         for (let i=0;i<vars.length;i++) {
                let pair = vars[i].split("=");
                if(pair[0] == "accountId"){
                    params.accountId = pair[1];
             }
         }
        }
        axios.defaults.headers.common["accountId"] = params.accountId;
        let res = axios.post(`${base.businessBase}`, params);
        return res;
    },


    //清除session
    // logout() {
    //     const params = {
           
    //     };
    //     let res = axios.post(`${base.logBase}`, params)
    //     return res;
    // },

 



    //登录调用传参
    addLogin(account, password, language) {
        const params = {
            "apiname": "srmmainpage",
            "methodname": "addLogin",
            "account": account.value,
            "password": password.value,
            "language": language
        };
        return axios.post(`${base.businessBase}`, params);
    },
};

export default mainpageApi;